<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <ul class="breadcrumb" v-if="subUser">
        <li>
          <router-link :to="{ name: 'ManageSubUser'}">{{'Manage Sub Users'|translate}}</router-link>
        </li>
        <li>{{subUser.name}}</li>
      </ul>
      <h3>{{'Manage Sale Log'|translate}}</h3>
      <div class="mt20">
        <a class="btn btn-primary" v-on:click="showModal(null)">{{'Add'|translate}}</a>
      </div>
      <loading v-if="list_items == null" class="mt20" :text="'Please wait'|translate"></loading>
      <p
        class="mt20 alert alert-info"
        v-if="list_items && list_items.length == 0"
      >{{'There is no data'|translate}}</p>
      <table class="table mt10" v-if="list_items && list_items.length > 0">
        <thead>
          <tr>
            <th width="25%">{{'Date'|translate}}</th>
            <th width="75%">{{'Summmary'|translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item) in list_items" :key="item.id">
            <td>{{ item.start_date | moment("DD/MM/YYYY") }}</td>
            <td>{{ item.summary }}</td>
          </tr>
        </tbody>
      </table>
      <paginate
        v-if="total_page > 1"
        :page-count="total_page"
        :click-handler="clickPage"
        :prev-text="'Prev'|translate"
        :next-text="'Next'|translate"
        v-model="page"
        :container-class="'pagination'"
      ></paginate>
    </div>
    <form-sale-log v-if="show_form" ref="formSaleLog" :user_id="userId" @modalData="modalData"></form-sale-log>
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import FormSaleLog from "@/components/SaleLog/FormSaleLog";
import Paginate from "vuejs-paginate";
import Loading from "@/components/elements/Loading";
export default {
  name: "Home",
  components: {
    MyHeader,
    FormSaleLog,
    Paginate,
    Loading
  },
  data() {
    return {
      subUser: null,
      show_form: false,
      list_items: null,
      removing: false,
      page: 1,
      offset: 0,
      keyword: "",
      limit: Utils.getLimit(),
      total_page: 1
    };
  },
  methods: {
    modalData(data) {
      
      this.list();
    },
    showModal() {
      this.show_form = true;
      setTimeout(() => {
        this.$refs.formSaleLog.open();
      });
    },
    list() {
      let data = {
        user_id: this.userId,
        offset: this.offset,
        limit: this.limit
      };
      
      Utils.request(this, true, "subuser")
        .get(`/manageSaleLog/?${Utils.arrayToRequestParam(data)}`)
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            let list = data.data.list;
            list = list.map(item => {
              let temp = new Date(parseInt(item.add_time) * 1000);
              item.add_date = this.$moment(temp);

              let temp1 = new Date(parseInt(item.start_time) * 1000);
              item.start_date = this.$moment(temp1);
              item.remain_text = Utils.getFormattedTime(this, item.add_date);
              return item;
            });
            this.list_items = list;
            this.total_page = Utils.getTotalPages(data.data.total);

            // update local storage
          }
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    },
    clickPage(pageNum) {
      this.offset = Utils.getNextOffset(pageNum);
      this.list();
    },
    getUser() {
      Utils.request(this, true, "subuser")
        .get(`/manageSubUser/${this.userId}`)
        .then(response => {
          let data = response.data;
          console.log("data", data);
          this.subUser = data.data;
        });
    }
  },
  mounted() {
    this.userId = this.$route.params.userId;
    this.getUser();
    this.list();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SaleLog/ManageSaleLog.vue